import { createApi } from "@reduxjs/toolkit/query/react";
import { queryParams } from "../../../utils/helper";
import { baseQueryWithAuth } from "../../BaseQueryWithAuth/baseQueryWithAuth";

export const dashboardApiService = createApi({
  reducerPath: "dashboardApi",
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    getSalesSummary: builder.mutation({
      query: ({ day, params }) => {
        let query = queryParams(params);
        return {
          url: `dashboard/getsales/summary/${day}${query}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetSalesSummaryMutation } = dashboardApiService;
